<template>
  <div class="desk-flex desk-flex--top no_mobile">
    <ListPdf
      :appointmentList="surgeryList"
      :selectedDate="selectedDate"
      :isSurgery="true"
    />
    <div class="calander_surg_side bg--blue-light tx--bege">
      <div class="calander_surg_side_sticky">
        <div
          v-if="!non_scheduled || !non_scheduled.length"
          class="center no-print"
        >
          <img style="margin-bottom:8px" src="/assets/img/svg/circ-close.svg" />
          <h2 class="mb--22 title--32">
            אין ניתוחים<br />
            הממתינים לשיבוץ
          </h2>
        </div>
        <div class="no-print" v-if="non_scheduled && non_scheduled.length">
          <h2 class="mb--15 title--32">ניתוחים לשיבוץ</h2>
          <div class="head_search relative">
            <input
              class="head_search_input none_scheduled_search_input"
              type="text"
              placeholder="סנן לפי ת.ז"
              v-model="query"
              v-on:keypress="numbersOnly"
              autocomplete="off"
            />
            <input class="head_search_submit" type="submit" value="" />
          </div>
          <div class="external-event-wrap has--scroll">
            <div
              class="external-event"
              v-for="surg in filteredNoneScheduled"
              :class="surg.isEdited ? 'edited-non-schedule' : ''"
              :key="surg.surgery_order_id"
              draggable="true"
              @dragstart="onEventDragStart($event, surg)"
              @click="
                $router.push(
                  '/surg-info/' +
                    (!surg.isEdited ? surg.surgery_order_id : surg.id)
                )
              "
            >
              <div>
                <span>{{ surg.patient_name + " " }}</span>
                <span>{{ surg.passport }}</span>
                <span v-if="surg.insurance_name">{{
                  " | " + surg.insurance_name
                }}</span>
                <span v-if="surg.phone">{{ " | " + surg.phone }}</span>
                <span v-if="surg.surgery_duration">{{
                  " | משך זמן הניתוח: " + surg.surgery_duration
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="calandr_main only-surg no_mobile calendar_desktop relative desk-is--fit"
      :class="{
        listDay: viewBySelect === 'list',
        'no-print': $route.name === 'surgeries'
      }"
    >
      <h2 class="tx--blue2 center only-print">מרפאת {{ activeDoctor.name }}</h2>

      <!-- list surg -->
      <surgery-list v-if="viewBySelect === 'list'" :surgeryList="surgeryList" />

      <!-- small calendar -->
      <div class="glob-date-in-surg relative no-print">
        <div
          @click="isDatePicker = !isDatePicker"
          v-click-outside="hide"
          class="glob-date-click tx--blue2 cursor-p flex"
        >
          {{ getSelectedDate }}
          <img src="/assets/img/svg/ic-date.svg" />
        </div>
        <div class="glob-date-open bg--white" v-show="isDatePicker">
          <vue-cal
            xsmall
            locale="he"
            :time="false"
            :startWeekOnSunday="true"
            :selected-date="selectedDate"
            hide-view-selector
            active-view="month"
            :disable-views="['years', 'year', 'week', 'day']"
            @cell-focus="onDatePicker"
            class="vuecal--green-theme vuecal--rounded-theme mini-month"
            :events="eventsSmallCal"
            events-count-on-year-view
            @view-change="changeSmallCalendar"
          >
            <template v-slot:weekday-heading="{ heading }">
              <span v-if="heading.label == 'ראשון'">א׳</span>
              <span v-if="heading.label == 'שני'">ב׳</span>
              <span v-if="heading.label == 'שלישי'">ג׳</span>
              <span v-if="heading.label == 'רביעי'">ד׳</span>
              <span v-if="heading.label == 'חמישי'">ה׳</span>
              <span v-if="heading.label == 'שישי'">ו׳</span>
              <span v-if="heading.label == 'שבת'">ש׳</span>
            </template>
            <template v-slot:events-count="{ events }">
              <span>
                {{ countDot(events) }}
              </span>
            </template>
          </vue-cal>
        </div>
      </div>

      <!-- calendar -->
      <vue-cal
        class="vuecal--green-theme scroll has--scroll-x no-print"
        locale="he"
        :startWeekOnSunday="true"
        hide-view-selector
        hide-weekends
        :disable-views="['years', 'year', 'month', 'week']"
        :time-from="timeFrom"
        :time-to="timeTo"
        :timeStep="timeStep"
        :snap-to-time="5"
        :timeCellHeight="50"
        :events="todayEvents"
        @event-drop="$e => dragOrChangeDuration($e, false)"
        @event-duration-change="$e => dragOrChangeDuration($e, true)"
        sticky-split-labels
        :split-days="splitDays"
        @view-change="initCalendarDesktop"
        :selected-date="selectedDate"
        :min-cell-width="200"
        :min-split-width="200"
        :on-event-click="onEventClick"
        :editable-events="{
          title: false,
          drag: true,
          resize: true,
          delete: false,
          create: false
        }"
      >
        <template #split-label="{ split }">
          {{ split.label }}
        </template>
        <template v-slot:event="{ event }">
          <div v-if="event.type === 'block' && !event.is_pending"></div>
          <div v-if="event.type === 'block' && event.is_pending">
            <div class="pending-title">ממתין לאישור מוקד הניתוחים</div>
          </div>
          <div
            v-if="event.event_type === 'surgery' || event.type === 'surgery'"
            class="surgery-green"
            :class="event.isEdited ? 'edited-event' : ''"
          >
            <!-- Label -->
            <div class="external-event">
              <div
                v-if="event.status"
                class="label-status surg-label"
                :class="getSurgStatusClass(event.status)"
              >
                {{ event.status }}
              </div>
              <span class="block ft--400">
                <span>{{ $moment(event.start).format("LT") + " - " }}</span>
                <span>{{ event.patient_name + " " }}</span>
              </span>

              <span>{{ event.passport }}</span>

              <span v-if="event.phone"> | {{ event.phone }}</span>
              <span v-if="event.orders && event.orders.length">
                |
                <div
                  style="display: inline-block;"
                  v-for="(side, i) in event.orders"
                  :key="side.id"
                >
                  {{ side.tafnit_code + " > " }}
                  <span class="small-text">{{ side.tafnit_name }}</span>
                  {{ i == event.orders.length - 1 ? "" : "," }}
                </div>
              </span>
              <span v-else-if="event.surgeryName" class="small-text">{{
                " | " + event.surgeryName
              }}</span>
              <span v-if="event.insurance_name">{{
                " | " + event.insurance_name
              }}</span>
              <span v-if="event.insurance_fee">{{
                " | סך השתתפות עצמית: ₪" + event.insurance_fee
              }}</span>
              <span v-if="event.insurance_status_heb">{{
                " | סטטוס התחייבות: " + event.insurance_status_heb
              }}</span>
              <span v-if="event.insurance_code">{{
                " | מספר התחייבות: " + event.insurance_code
              }}</span>
              <span v-if="event.patient_age">{{
                " | גיל המטופל: " + event.patient_age
              }}</span>
              <span v-if="event.gender">{{ " | מגדר: " + event.gender }}</span>
            </div>

            <!-- DOTS ELEMENT -->
            <button class="nav-dots flex flex--end">
              <span class="nav-dot"></span>
            </button>
            <!-- DOTS MENU -->
            <SurgDotsMenu
              v-if="event.bg_menu && event.type === 'surgery'"
              v-click-outside="ev => hideEditBlock(event, ev)"
              :event="event"
              :isSelectedDatePassed="isSurgeryPassed"
              isDesktop="true"
            />
            <!-- END DOTS MENU -->
          </div>
        </template>
      </vue-cal>

      <!-- Time -->
      <TimeRangeArrows
        v-if="viewBySelect != 'list'"
        @updateTimeStep="updateTimeStep"
      />

      <!-- select view -->
      <div
        class="bt_blue no_mobile only-list-day-print bg-block"
        v-if="showSaveSurgeriesButton"
        :class="isSaveButtonActive ? '' : 'disabled'"
        @click="isSaveButtonActive ? saveEvents() : null"
      >
        שמירה
      </div>
      <div class="select-month-wrap select-month-wrap-left no-print">
        <select2 v-model="viewBySelect">
          <option
            :value="view.value"
            v-for="view in viewOptions"
            :key="view.value"
          >
            {{ view.text }}
          </option>
        </select2>
      </div>
    </div>
  </div>
</template>

<script>
import VueCal from "vue-cal";
import "vue-cal/dist/drag-and-drop.es.js";
import "vue-cal/dist/i18n/he.es.js";
import "vue-cal/dist/vuecal.css";
import { mapGetters } from "vuex";
import ClickOutside from "vue-click-outside";
import Error from "@/components/Popups/Error";
import UnsavedChangesAlert from "@/components/Popups/UnsavedChangesAlert";
import SurgeryList from "@/components/Dashboard/List/SurgeryList";
import ListPdf from "@/components/Shared/ListPdf";
import CancelPop from "@/components/Popups/CancelApp";
import TimeRangeArrows from "@/components/Shared/TimeRangeArrows";
import { getHash } from "../../../utilities/hash.js";
import { buildSurgeryEvent } from "../../../utilities/build-type-event";
import { numbersOnly } from "../../../utilities/globals";
import { isDatePassed } from "../../../utilities/dates.js";
import SMSToPatient from "../../Popups/SMSToPatient.vue";
import Whatsapp from "../../Popups/Whatsapp.vue";
import SurgEditErrors from "../../Popups/SurgEditErrors.vue";
import { getSurgeryErrorPopup } from "../../../utilities/get-init-popup";
import SurgDotsMenu from "./SurgDotsMenu.vue";
import AddDocuments from "@/components/Popups/AddDocuments";

export default {
  name: "SurgeriesDesktop",
  components: {
    VueCal,
    SurgeryList,
    ListPdf,
    TimeRangeArrows,
    SurgDotsMenu
  },
  props: {
    events: {
      type: Array,
      require: true
    },
    smallCalEvents: {
      type: Array,
      require: true
    },
    showSaveSurgeriesButton: {
      type: Boolean,
      require: true
    }
  },
  directives: {
    ClickOutside
  },
  data() {
    return {
      viewOptions: [
        { value: "day", text: "תצוגה יומית" },
        { value: "list", text: "רשימת ניתוחים" }
      ],
      viewBySelect: "day",
      non_scheduled: null,
      selectedDate: new Date(),
      splitDays: [],
      isDatePicker: false,
      /**
       * @constant copyEvents holds the original
       * events comming from API. It's value
       * will not change.
       */
      copyEvents: [],
      /**
       * @constant todayEvents is the array that keeps
       * all the changes of dragging, droping and
       * changing duration to events.
       */
      todayEvents: [],
      /**
       * In case where we have schedules events
       * already, and we made changes and removed
       * them, they will enter @constant eventsToReschedule
       * and removed when saveEvents will be called
       */
      eventsToReschedule: [],
      isSaveButtonActive: true,
      /**
       * We use this standbySelectedDate for storing
       * the selected date when a user is trying to
       * move between dates while isSaveButtonActive
       * is active.
       *
       * Check canMoveBetweenDates function for more
       * details
       *
       * @type {Date | null}
       */
      standbySelectedDate: null,
      timeStep: 15,
      query: ""
    };
  },
  computed: {
    ...mapGetters(["allRooms", "doctorRooms", "activeDoctor"]),
    getSelectedDate() {
      return this.$moment(this.selectedDate).format("L");
    },
    isSurgeryPassed() {
      return this.isDatePassed(this.selectedDate);
    },
    eventsSmallCal() {
      if (!this.smallCalEvents || !this.smallCalEvents.length) return [];
      let tmp = this.splitEvents(this.smallCalEvents);
      return tmp.filter(ev => {
        const key = ev.room ? ev.room.key : "";
        return (
          key &&
          (key.includes("surgery") ||
            key.includes("gastro") ||
            key.includes("ivf") ||
            key.includes("catheterization")) &&
          key !== "surgery_10" &&
          key !== "surgery_11"
        );
      });
    },
    scaleHour() {
      if (!this.copyEvents || !this.copyEvents.length) {
        return { min: 0, max: 0 };
      }

      const today = this.$moment(this.selectedDate).startOf("day");
      const evDates = this.copyEvents.filter(ev =>
        this.$moment(ev.start).isSame(today, "day")
      );

      const hoursStart = evDates.map(d => this.$moment(d.start).hours());
      const min = Math.min(...hoursStart);

      const hoursEnd = evDates.map(d => this.$moment(d.end).hours());
      const max = Math.max(...hoursEnd);

      return { min, max };
    },
    timeFrom() {
      if (!this.scaleHour.min) {
        return 0;
      } else if (this.scaleHour.min === Infinity) {
        const day = this.$moment(this.selectedDate).day();
        return day === 5 ? 8 * 60 : 7 * 60;
      } else {
        return (this.scaleHour.min - 1) * 60;
      }
    },
    timeTo() {
      if (!this.scaleHour.max) {
        return 3 * 60;
      } else if (
        this.scaleHour.max === 24 ||
        this.scaleHour.max === -Infinity
      ) {
        const day = this.$moment(this.selectedDate).day();
        return day === 5 ? 11 * 60 : 23 * 60;
      } else if (
        this.scaleHour.max - this.scaleHour.min < 6 &&
        this.scaleHour.max + 6 < 24
      ) {
        return (this.scaleHour.max + 6) * 60;
      } else {
        return (this.scaleHour.max + 1) * 60;
      }
    },
    surgeryList() {
      if (!this.events || !this.selectedDate) return [];
      const tody = this.getDate(this.selectedDate);
      const eventsTody = this.events.filter(
        e => e.type === "surgery" && tody === this.getDate(e.start)
      );
      const sortedTodayEv = eventsTody.sort((a, b) => a.start - b.start);
      return sortedTodayEv;
    },
    filteredNoneScheduled() {
      if (!this.query) return this.non_scheduled;
      return this.non_scheduled.filter(ev => ev.passport.includes(this.query));
    }
  },
  methods: {
    numbersOnly,
    isDatePassed,
    /**
     * format for time
     * @param {object} Date
     * @returns {String} HH:mm
     */
    getTime(date) {
      return this.$moment(date).format("LT");
    },
    /**
     * format for date
     * @param {object} Date
     * @returns {String} DD/MM/YYYY
     */
    getDate(date) {
      return this.$moment(date).format("L");
    },
    /**
     * check if surgery is before today
     * @param {object} Date
     * @returns {bool}
     */
    isBeforeToday(date) {
      /// for now always true, backend issue
      return true;
      return new Date() > date;
    },
    /**
     * get room by split
     * @param {String} split key
     * @returns {object} room
     */
    getRoomBySplit(key) {
      const find = this.copyEvents.find(e => e.split == key);
      if (find) return find.room;
      return null;
    },
    /** vue cal function - trigger when drag start */
    onEventDragStart(e, draggable) {
      const duration = this.$moment
        .duration(draggable.surgery_duration)
        .asMinutes();
      const draggableEdit = {
        ...draggable,
        duration
      };
      e.dataTransfer.setData("event", JSON.stringify(draggableEdit));
      e.dataTransfer.setData("cursor-grab-at", e.offsetY);
    },
    /**
     * First, we check if the event if outside
     * the room. Then we want to build the event
     * as an specific object with buildEventObj.
     * In case the event was dropped from non_scheduled
     * we need to remove it from there as well.
     * Finally no matter which event accured, we
     * show our save button.
     *
     * Be aware that the order of this function matters
     *
     * We change the place of the event only inside
     * todayEvents.
     *
     * @param {object} event comming from Vue-cal
     * whenever we trigger drop or change duration
     *
     * @param {bool} isChangeDuration telling if
     * change duration event or drop event accured
     */
    dragOrChangeDuration({ event }, isChangeDuration) {
      if (event.type === "block") return;

      /// User trying to place event on date before today
      if (new Date() > event.start) {
        this.copyEvents = [...this.copyEvents];
        this.todayEvents = [...this.todayEvents];
        this.$modal.show(Error, {
          title: "ניתן לשנות שיבוץ ניתוח/תור בתאריך נוכחי או עתידי בלבד"
        });
        return;
      }

      /// Checking if event comes from non_scheduled events
      let nonSchedEventIndex;
      if (!isChangeDuration) {
        nonSchedEventIndex = this.non_scheduled.findIndex(
          item =>
            item.surgery_order_id === event.surgery_order_id &&
            item.id === event.id
        );
      }

      const obj = this.buildEventObj(event, true, nonSchedEventIndex == -1);
      const blockId = this.findBlock(obj.start, obj.end, obj.split);
      const newTimeSurge = this.getFixedSurgTime(obj.start, obj.end, obj.split);

      /// User placed event ENTIRELY outside of a block
      if (newTimeSurge === null && blockId === null) {
        this.todayEvents = [...this.todayEvents];
        this.$modal.show(Error, {
          title: "לתשומת ליבך, לא ניתן לשבץ מחוץ לשעות הבלוק שהוגדרו"
        });
        return;
      }

      /// Removing event from non_scheduled events
      if (nonSchedEventIndex !== undefined && nonSchedEventIndex !== -1) {
        this.non_scheduled.splice(nonSchedEventIndex, 1);
      }

      /// adjustmentSurgTime succeded to guess where to
      if (newTimeSurge !== null) {
        obj.start = new Date(newTimeSurge.start);
        obj.end = new Date(newTimeSurge.end);
      }

      const index = this.todayEvents.findIndex(
        ev => ev.id === obj.id && ev.type === "surgery"
      );

      this.setIsSaveButtonActive(obj);

      if (index === -1) this.todayEvents.push(obj);
      else this.todayEvents[index] = obj;

      this.todayEvents = [...this.todayEvents];

      if (!this.showSaveSurgeriesButton) {
        this.$emit("setShowSaveSurgeriesButton", true);
      }
    },
    /**
     * Function checks if any events collides with
     * the event passed. If so, our save button
     * will become disabled.
     *
     * @param {object} event that changed
     * his start or end properties. This object
     * structure is coming from buildEventObj.
     */
    setIsSaveButtonActive(event) {
      if (event === undefined) {
        this.isSaveButtonActive = true;
        return;
      }
      const blockId = this.findBlock(event.start, event.end, event.split);
      const isFindSurg = this.findSurg(event);
      const hasNoDuration = this.todayEvents.some(
        e => e.start.toString() === e.end.toString()
      );

      this.isSaveButtonActive = !(!blockId || isFindSurg || hasNoDuration);
    },
    /**
     * This function replaces the adjustmentSurgTime function below.
     *
     * This function is trying to guess where
     * the user might wanted to drop an event
     * in case they tried to put it a bit outside
     * the of a block
     *
     * @param {Date} start
     * @param {Date} end
     * @param {String} appId
     * @param {object} split
     *
     * @returns {object | null} if event dropped in an invalid
     * area and the function didn't find anywhere close
     * to put it, null will return. Else, return {object} with
     * the properties of wherethe user might tried to place
     * the event
     *
     * @example { start: {Date}, end: {Date}, blockId: {Number} }
     */
    getFixedSurgTime(start, end, split) {
      const wantedDateStart = this.$moment(start);
      const wantedDateEnd = this.$moment(end);
      const duration = this.$moment
        .duration(wantedDateEnd.diff(wantedDateStart))
        .asMinutes();

      /// Find block
      let block = null;
      let blocks = this.todayEvents.filter(
        ev => ev.type === "block" && ev.split === split && !ev.is_pending
      );
      if (!blocks || !blocks.length) return null;
      for (let i = 0; i < blocks.length; i++) {
        const blockStart = this.$moment(blocks[i].start);
        const blockEnd = this.$moment(blocks[i].end);
        if (
          wantedDateEnd.isSameOrAfter(blockStart) &&
          blockEnd.isSameOrAfter(wantedDateStart)
        ) {
          block = { ...blocks[i] };
          break;
        }
      }
      if (!block) return null;

      const blockStart = this.$moment(block.start);
      const blockEnd = this.$moment(block.end);

      /// Before block start
      if (wantedDateStart.isBefore(blockStart)) {
        let newEnd = this.$moment(block.start).add(duration, "minutes");
        newEnd = new Date(newEnd.format("YYYY-MM-DDTHH:mm"));

        return { start: block.start, end: newEnd, blockId: block.id };
      }

      /// After block end
      if (wantedDateEnd.isAfter(blockEnd)) {
        let newStart = this.$moment(block.end).subtract(duration, "minutes");
        newStart = new Date(newStart.format("YYYY-MM-DDTHH:mm"));

        return { start: newStart, end: block.end, blockId: block.id };
      }
      return null;
    },
    /**
     * @deprecated please use getFixedSurgTime function instead.
     *
     * This function is trying to guess where
     * the user might wanted to drop an event.
     *
     * @param {Date} start
     * @param {Date} end
     * @param {String} appId
     * @param {object} split
     *
     * @returns {object | null} if event dropped in an invalid
     * area and the function didn't find anywhere close
     * to put it, null will return. Else, return {object} with
     * the properties of wherethe user might tried to place
     * the event
     *
     * @example { start: {Date}, end: {Date}, blockId: {Number} }
     */
    adjustmentSurgTime(start, end, appId, split) {
      const wantedDateStart = this.$moment(start);
      const wantedDateEnd = this.$moment(end);
      const duration = this.$moment
        .duration(wantedDateEnd.diff(wantedDateStart))
        .asMinutes();
      /// find block
      let block = null;
      // let blocks = this.copyEvents.filter(
      let blocks = this.todayEvents.filter(
        ev =>
          ev.type === "block" &&
          this.getDate(start) === this.getDate(ev.start) &&
          ev.split === split &&
          !ev.is_pending
      );
      if (!blocks || !blocks.length) return null;
      for (let i = 0; i < blocks.length; i++) {
        const blockStart = this.$moment(blocks[i].start, "YYYY-MM-DD HH:mm:ss");
        const blockEnd = this.$moment(blocks[i].end, "YYYY-MM-DD HH:mm:ss");
        if (
          wantedDateEnd.isSameOrAfter(blockStart) &&
          blockEnd.isSameOrAfter(wantedDateStart)
        ) {
          block = blocks[i];
          break;
        }
      }
      if (!block) return null;
      /// find apps
      // let todayApps = this.copyEvents.filter(
      //   ev =>
      //     ev.type === "surgery" &&
      //     this.getDate(start) === this.getDate(ev.start) &&
      //     ev.split === split &&
      //     ev.id !== appId
      // );
      const blockStart = this.$moment(block.start, "YYYY-MM-DD HH:mm:ss");
      const blockEnd = this.$moment(block.end, "YYYY-MM-DD HH:mm:ss");
      /// if not apps
      // if (!todayApps || !todayApps.length) {
      if (wantedDateStart.isBefore(blockStart)) {
        /// before block start
        let newEnd = this.$moment(block.start, "YYYY-MM-DD HH:mm:ss").add(
          duration,
          "minutes"
        );
        if (blockEnd.isSameOrAfter(newEnd)) {
          newEnd = new Date(newEnd.format("YYYY-MM-DDTHH:mm"));
          return { start: block.start, end: newEnd, blockId: block.id };
        }
      } else if (wantedDateEnd.isAfter(blockEnd)) {
        /// after block end
        let newStart = this.$moment(block.end, "YYYY-MM-DD HH:mm:ss").subtract(
          duration,
          "minutes"
        );
        if (newStart.isSameOrAfter(blockStart)) {
          newStart = new Date(newStart.format("YYYY-MM-DDTHH:mm"));
          return { start: newStart, end: block.end, blockId: block.id };
        }
      }
      return null;

      // }
      /// Old logic, not in use for now
      /// if apps
      todayApps = todayApps.sort((a, b) => a.start - b.start);
      for (let i = 0; i < todayApps.length; i++) {
        const appStart = this.$moment(
          todayApps[i].start,
          "YYYY-MM-DD HH:mm:ss"
        );
        const appEnd = this.$moment(todayApps[i].end, "YYYY-MM-DD HH:mm:ss");
        /// before block start
        if (wantedDateStart.isBefore(blockStart) && i == 0) {
          let newEnd = this.$moment(block.start, "YYYY-MM-DD HH:mm:ss").add(
            duration,
            "minutes"
          );
          if (appStart.isSameOrAfter(newEnd) && newEnd.isBefore(blockEnd)) {
            newEnd = new Date(newEnd.format("YYYY-MM-DDTHH:mm"));
            return { start: block.start, end: newEnd, blockId: block.id };
          }
        }
        /// after block end
        if (wantedDateEnd.isAfter(blockEnd)) {
          const lastAppEnd = this.$moment(
            todayApps[todayApps.length - 1].end,
            "YYYY-MM-DD HH:mm:ss"
          );
          let newStart = this.$moment(
            block.end,
            "YYYY-MM-DD HH:mm:ss"
          ).subtract(duration, "minutes");
          if (
            newStart.isSameOrAfter(lastAppEnd) &&
            newStart.isAfter(blockStart)
          ) {
            newStart = new Date(newStart.format("YYYY-MM-DDTHH:mm"));
            return { start: newStart, end: block.end, blockId: block.id };
          }
        }
        /// between apps
        if (wantedDateStart.isAfter(appStart) && todayApps[i + 1]) {
          let nextAppStart = this.$moment(
            todayApps[i + 1].start,
            "YYYY-MM-DD HH:mm:ss"
          );
          /// wanted start before app end
          if (wantedDateStart.isBefore(appEnd)) {
            let newEnd = this.$moment(
              todayApps[i].end,
              "YYYY-MM-DD HH:mm:ss"
            ).add(duration, "minutes");
            if (
              nextAppStart.isSameOrAfter(newEnd) &&
              newEnd.isBefore(blockEnd)
            ) {
              newEnd = new Date(newEnd.format("YYYY-MM-DDTHH:mm"));
              return { start: appEnd, end: newEnd, blockId: block.id };
            }
            break;
          }
          /// wanted end after start app
          if (wantedDateEnd.isAfter(nextAppStart)) {
            let newStart = this.$moment(
              todayApps[i + 1].start,
              "YYYY-MM-DD HH:mm:ss"
            ).subtract(duration, "minutes");

            if (
              nextAppStart.isSameOrAfter(newStart) &&
              newStart.isSameOrAfter(appEnd) &&
              newStart.isAfter(blockStart)
            ) {
              newStart = new Date(newStart.format("YYYY-MM-DDTHH:mm"));
              return {
                start: newStart,
                end: nextAppStart.format("YYYY-MM-DDTHH:mm"),
                blockId: block.id
              };
            }
          }
        }
      }
      return null;
    },
    /**
     * Get new props events - home function
     * @param {object} event from vue cal
     */
    initCalendarDesktop(ev) {
      if (this.standbySelectedDate) return;

      this.standbySelectedDate = ev.startDate;
      const canMoveOn = this.canMoveBetweenDates();
      if (!canMoveOn) {
        this.selectedDate = new Date(this.selectedDate);
        return;
      }

      this.selectedDate = this.standbySelectedDate;
      window.location.hash = getHash({
        date: this.selectedDate.format("YYYY-MM-DD"),
        view: "day"
      });
      this.$emit("initCalendarDesktop", {
        currentDate: new Date(this.selectedDate)
      });
      this.standbySelectedDate = null;
    },
    /**
     * Get new props events for small calendar - home function
     * @param {object} event from vue cal
     */
    changeSmallCalendar(ev) {
      this.$emit("initCalendarDesktop", {
        currentDate: new Date(ev.startDate),
        type: "small"
      });
    },
    /** Count number of surgeries for small calendar */
    countDot(events) {
      if (!events || !events.length) return 0;
      return events.filter(e => e.type === "surgery").length;
    },
    /** On clicking outside of dots-menu */
    hideEditBlock(ev, event) {
      if (event.target.className.includes("nav-dots flex flex--end")) return;
      const index = this.todayEvents.findIndex(event => event.id === ev.id);
      this.todayEvents[index].bg_menu = false;
    },
    /** Trigger when chose day in small calendar */
    onDatePicker(ev) {
      this.standbySelectedDate = ev;
      const canMoveOn = this.canMoveBetweenDates();
      if (!canMoveOn) return;

      this.selectedDate = ev;
      window.location.hash = getHash({
        date: this.selectedDate.format("YYYY-MM-DD"),
        view: "day"
      });
      this.$emit("initCalendarDesktop", {
        currentDate: new Date(this.selectedDate)
      });
      this.isDatePicker = false;
      this.standbySelectedDate = null;
    },
    /** Trigger when click outside small calendar */
    hide(ev) {
      if (
        !this.isDatePicker ||
        ev.target.ariaLabel === "Next month" ||
        ev.target.ariaLabel === "Previous month"
      )
        return;
      this.isDatePicker = false;
    },
    /**
     * Finding if the event inside block
     * any existing events.
     *
     * @param {Date} start
     * @param {Date} end
     * @param {String} split room key
     *
     * @returns {String} block id
     * @returns {null} if not found block
     */
    findBlock(start, end, split) {
      let startHApp = this.getTime(start);
      let endHApp = this.getTime(end);
      if (endHApp == "00:00") endHApp = "23:59";

      let todayEv = [];
      // this.copyEvents.forEach(ev => {
      this.todayEvents.forEach(ev => {
        if (
          ev.type === "block" &&
          this.getDate(start) === this.getDate(ev.start) &&
          ev.split === split &&
          !ev.is_pending
        ) {
          const hourS = this.getTime(ev.start);
          const hourE = this.getTime(ev.end);
          todayEv.push({ ...ev, start: hourS, end: hourE });
        }
      });
      if (!todayEv || !todayEv.length) {
        return null;
      } else if (todayEv.length === 1) {
        if (startHApp >= todayEv[0].start && endHApp <= todayEv[0].end) {
          return todayEv[0].id;
        } else {
          return null;
        }
      } else if (todayEv.length > 1) {
        let selectedId = null;
        todayEv.forEach(ev => {
          if (startHApp >= ev.start && endHApp <= ev.end) selectedId = ev.id;
        });
        return selectedId;
      }
      return null;
    },
    /**
     * Finding if the event passed is between
     * any existing events.
     *
     * @param {object} event structured as
     * returns in buildEventObj
     *
     * @returns {Boolean}
     */
    findSurg(event) {
      const { start, end, split, id } = event;
      let wanted_date_start = this.$moment(start);
      let wanted_date_end = this.$moment(end);

      let todayEv = [];
      // this.copyEvents.forEach(ev => {
      this.todayEvents.forEach(ev => {
        if (
          ev.type === "surgery" &&
          this.getDate(start) === this.getDate(ev.start) &&
          ev.split === split &&
          ev.id !== id
        ) {
          todayEv.push(ev);
        }
      });
      if (!todayEv.length) return false;
      const sortedTodayEv = todayEv.sort((a, b) => a.start - b.start);
      let error_need_to_short = false;
      let error_contain_app = false;

      for (const index in sortedTodayEv) {
        const appointment = sortedTodayEv[index];
        const appointement_start = this.$moment(
          appointment.start,
          "YYYY-MM-DD HH:mm:ss"
        );
        const appointement_end = this.$moment(
          appointment.end,
          "YYYY-MM-DD HH:mm:ss"
        );
        if (
          (wanted_date_start.isAfter(appointement_start) &&
            wanted_date_start.isBefore(appointement_end)) ||
          (wanted_date_end.isAfter(appointement_start) &&
            wanted_date_end.isBefore(appointement_end))
        ) {
          error_need_to_short = true;
        }
        if (
          (wanted_date_start.isSameOrBefore(appointement_start) &&
            wanted_date_end.isSameOrAfter(appointement_end)) ||
          (wanted_date_start.isSame(appointement_start) &&
            wanted_date_end.isSame(appointement_end))
        ) {
          error_contain_app = true;
        }
      }
      if (error_need_to_short || error_contain_app) {
        return true;
      }
      return false;
    },
    /** Get splits by selected date for vue cal */
    getSplitDays() {
      this.splitDays = [];
      if (!this.events || !this.events.length) {
        return;
      }
      const isApp = this.events.filter(ev => ev.type == "appointment");
      if (isApp.length) return;

      let find = null;
      this.events.forEach(ev => {
        const evStart = this.$moment(ev.start).format("YYYY-MM-DD");
        const select = this.$moment(this.selectedDate).format("YYYY-MM-DD");
        if (
          evStart == select &&
          ev.room &&
          ev.room.key !== "surgery_10" &&
          ev.room.key !== "surgery_11"
        ) {
          if (this.splitDays && this.splitDays.length) {
            find = this.splitDays.find(room => room.id == ev.room.key);
          }
          if (!find) {
            this.splitDays.push({
              id: ev.room.key,
              label: ev.room.value.name
            });
          }
        }
        find = null;
      });

      this.splitDays = this.splitDays.sort((a, b) => {
        return a.id.localeCompare(b.id);
      });
    },
    /** First function get date from hash url */
    initSelectedDate() {
      const hasDate = this.hashData ? this.hashData.date : false;
      if (hasDate) {
        this.selectedDate = new Date(hasDate);
      } else if (this.events && this.events.length) {
        const isApp = this.events.filter(ev => ev.type == "appointment");
        if (isApp.length) {
          this.selectedDate = new Date();
          return;
        }
        for (let i = 0; i < this.events.length; i++) {
          const ev_start = this.$moment(
            this.events[i].start,
            "YYYY-MM-DD HH:mm:ss"
          );
          const today = this.$moment(new Date());
          if (
            ev_start.isAfter(today) &&
            this.events[i].room.key !== "surgery_10" &&
            this.events[i].room.key !== "surgery_11"
          ) {
            this.selectedDate = this.events[i].start;
            window.location.hash = getHash({
              date: this.selectedDate.format("YYYY-MM-DD"),
              view: "day"
            });
            break;
          }
        }
      } else {
        this.selectedDate = new Date();
      }
    },
    /** Get none schedule events */
    getNonScheduleEvents() {
      if (!this.activeDoctor || !this.activeDoctor.id) return;
      this.$API
        .getNonScheduleEvents(
          "surgery_gastro_catheterization",
          this.activeDoctor.id
        )
        .then(res => {
          this.non_scheduled = res.map(ev => {
            return { ...ev, duration: 30 };
          });
        });
    },
    /** Get copy events from prop events */
    getCopyEvents(newEvents = null) {
      const events = newEvents ? newEvents : this.events;
      if (!events || !events.length) return;
      let tmp = events.map(ev => {
        if (ev.room && ev.room.key) {
          return { ...ev, split: ev.room.key };
        }
        return { ...ev };
      });
      tmp = this.splitEvents(tmp);
      this.copyEvents = tmp.filter(
        ev =>
          ev.room &&
          ev.room.key !== "surgery_10" &&
          ev.room.key !== "surgery_11"
      );
      this.hideOverflowingSurgeries();
      if (!this.standbySelectedDate) this.filterTodayEvents();
    },
    /**
     * This funciton sets the value of
     * todayEvents, all the events found for
     * selectedDate including the blocks themselfs.
     *
     * Pushes all the non block events with a
     * specific object structure comes from
     * buildEventObj
     */
    filterTodayEvents() {
      const today = this.getDate(this.selectedDate);
      this.todayEvents = this.copyEvents.filter(
        ev => today === this.getDate(ev.start)
      );
      this.todayEvents = this.todayEvents.map(e => {
        if (e.type === "block") return e;
        return this.buildEventObj(e, false);
      });
    },
    /**
     * Event click can do two things. If the user clicked
     * on the div itself, we change the route.
     *
     * Else, we want to remove the event but we need
     * to check if the user is in the middle of changes.
     * Also we need to check if the event is already
     * scheduled or an unsaved event the user dropped.
     *
     * @param {object} ev event we show to the user, with
     * type of 'surgery'
     *
     * @param {*} e event comes from the div the user
     * clicked.
     */
    onEventClick(ev, e) {
      const classList = [...e.target.classList];
      /// Open dot-menu
      if (classList.includes("nav-dots") || classList.includes("nav-dot")) {
        const index = this.todayEvents.findIndex(event => event.id === ev.id);
        const bgMenuIsTrue = this.todayEvents[index].bg_menu;
        this.todayEvents.forEach(event => (event.bg_menu = false));
        setTimeout(() => {
          if (bgMenuIsTrue) return;
          this.todayEvents[index].bg_menu = !this.todayEvents[index].bg_menu;
        }, 100);
        return;
      }
      /// Clicked to reschedule
      if (
        classList.includes("scheduling-svg") ||
        classList.includes("resched-btn")
      ) {
        if (!this.showSaveSurgeriesButton) {
          this.showCancelSurgPopup(ev, true);
          return;
        }

        const alreadyExistEvent = this.copyEvents.find(
          event => event.id === ev.id
        );

        if (alreadyExistEvent) {
          this.eventsToReschedule.push(ev);
        }
        ev.isEdited = true;
        this.non_scheduled.push(ev);
        const index = this.todayEvents.findIndex(event => event.id === ev.id);
        this.todayEvents.splice(index, 1);

        this.setIsSaveButtonActive(this.todayEvents[index]);
        return;
      }
      // Clicked to edit
      if (classList.includes("edit-btn")) {
        this.$router.push("/surg-edit/" + ev.id);
        return;
      }
      // Clicked to add docs
      if (classList.includes("doc-btn")) {
        this.$modal.show(AddDocuments, { directUpload: ev });
        return;
      }
      // Clicked to send special approval
      if (classList.includes("special-approval-btn")) {
        this.$router.push({
          name: "surg-special-approval",
          params: { id: ev.id }
        });
        return;
      }
      // Clicked to send SMS
      if (classList.includes("sms-btn")) {
        if (!this.showSaveSurgeriesButton) {
          this.$modal.show(SMSToPatient, {
            patientName: ev.patient_name,
            patientPassport: ev.passport,
            surgId: ev.id,
            eventType: "surgery"
          });
          return;
        }
      }
      if (classList.includes("whatsapp-btn")) {
        if (!this.showSaveSurgeriesButton) {
          this.$modal.show(Whatsapp, {
            patientPhone: ev.phone
          });
          return;
        }
      }

      /// Clicked to see the event
      if (ev.id && ev.type == "surgery") {
        this.$router.push("/surg-info/" + ev.id);
      }
    },
    getSurgStatusClass(type) {
      return this.$store.getters["getSurgStatusClass"](type);
    },
    updateTimeStep(isIncrease) {
      if (isIncrease && this.timeStep < 120) this.timeStep += 15;
      else if (!isIncrease && this.timeStep > 15) this.timeStep -= 15;
      this.hideOverflowingSurgeries();
    },
    showCancelSurgPopup(event, type = false) {
      if (event.tafnit_receipt_no) {
        const { popup, args } = getSurgeryErrorPopup();
        this.$modal.show(popup, { ...args });
        return;
      }

      this.$modal.show(
        CancelPop,
        {
          appointment_id: event.id,
          appDate: "",
          isSurg: true,
          type: type,
          openOnCalendar: true
        },
        {
          clickToClose: true
        }
      );
    },
    /**
     * At first, we send API requests for reschedule
     * all the eventsToReschedule events.
     *
     * After that, we take all the events in
     * todayEvents which are not typed as 'block'
     * and sending API requests to schedule them.
     *
     * We need to wait a bit before we refresh
     * user's view so the backend could send a
     * response with updated data.
     */
    async saveEvents() {
      try {
        if (this.eventsToReschedule.length !== 0) {
          for (const event of this.eventsToReschedule) {
            await this.$API.deleteSurgery(event.id, true);
          }
        }

        const promises = [];
        const errors = [];
        for (const ev of this.todayEvents) {
          if (ev.type === "block") continue;
          if (!ev.isEdited) continue;
          const blockId = this.findBlock(ev.start, ev.end, ev.split);

          promises.push(
            new Promise(async (res, rej) => {
              try {
                await this.$API.setSurgeryDateTime(
                  ev.id,
                  blockId,
                  this.$moment(ev.start).format("YYYY-MM-DDTLT:00"),
                  this.$moment(ev.end).format("YYYY-MM-DDTLT:00")
                );
                res({ ...ev, message: "" });
              } catch (error) {
                rej({ ...error, ...ev });
              }
            })
          );
        }

        const values = (await Promise.allSettled(promises)).filter(
          v => v.status === "rejected"
        );
        if (values.length) {
          for (const value of values) {
            const { passport, patient_name, insurance_name } = value.reason;
            const condition = value.reason.message.includes(
              "אינה מאושרת לרופא זה"
            );

            errors.push({
              passport,
              patient_name,
              insurance_name,
              reason: condition
                ? "אין הרשאה לביצוע הניתוח"
                : "ביטוח אחריות מקצועית פג תוקף"
            });
          }
        }
        if (errors.length) {
          this.$modal.show(SurgEditErrors, { errors });
          await this.getNonScheduleEvents();
          // values.forEach(v => this.non_scheduled.push(v.reason));
        }

        this.$emit("initCalendarDesktop", {
          currentDate: this.selectedDate,
          forceUpdate: true,
          type: "both"
        });
        this.todayEvents.forEach(e => (e.isEdited = false));
        this.non_scheduled.forEach(e => (e.isEdited = false));

        this.$emit("setShowSaveSurgeriesButton", false);
        this.standbySelectedDate = null;
      } catch (error) {
        console.log(error);
        this.$modal.show(Error);
      }
    },
    /**
     * Trigger this function while the user is trying
     * to change the date. It will check if any changes
     * are made to todayEvents and return if the user
     * can change or not. This function also opens an
     * alert popup.
     *
     * @returns {boolean}
     */
    canMoveBetweenDates() {
      if (!this.showSaveSurgeriesButton) return true;
      this.$modal.show(UnsavedChangesAlert, {
        confirmFunc: this.confirmUndoChanges
      });
      return false;
    },
    /**
     * @param {boolean} confirm is user confirm to
     * remove all changes.
     */
    confirmUndoChanges(confirm = false) {
      if (!confirm) {
        this.standbySelectedDate = null;
        return;
      }

      this.selectedDate = this.standbySelectedDate;
      window.location.hash =
        "&date=" + this.selectedDate.format("YYYY-MM-DD") + "&view=day";
      this.$emit("initCalendarDesktop", {
        currentDate: new Date(this.selectedDate)
      });

      this.eventsToReschedule = [];
      this.$emit("setShowSaveSurgeriesButton", false);
      this.standbySelectedDate = null;
    },
    /**
     *
     * @param {object} event the block we want to convert
     * into an event.
     *
     * @param {Boolean} edited will be false only at initial
     * todayEvents creation, After that every event will
     * be edited.
     *
     * @param {Boolean} hasType represents if the event comes
     * from non_scheduled events, so it does not contain a type
     *
     * @returns {object} event to work with todayEvents
     */
    buildEventObj(event, edited = true, hasType) {
      const obj = buildSurgeryEvent(event);
      obj.start = event.start;
      obj.end = event.end;
      obj.id = event.id ? event.id : event.surgery_order_id;
      obj.type = hasType ? event.type : "surgery";
      obj.isEdited = edited;
      obj.status = event.status;
      obj.split = event.split;
      obj.phone = event.phone;
      obj.patient_name = event.patient_name;
      obj.gender = event.gender;

      return obj;
    },
    hideOverflowingSurgeries() {
      const eventContainers = document.querySelectorAll(".surgery-green");
      eventContainers.forEach(c => {
        if (c.parentElement.clientHeight < 80) {
          c.querySelector(".external-event").classList.add(
            "short-surg-desktop"
          );
        }
      });
    },
    splitEvents(events) {
      const updatedEvents = [];

      events.forEach(event => {
        const startTime = this.$moment(event.start);
        const endTime = this.$moment(event.end);

        if (startTime.date() !== endTime.date()) {
          const midnight = this.$moment(startTime).endOf("day");
          const event1End = this.$moment(midnight);
          // const midnight2 = this.$moment(startTime).startOf("day");
          // const event2Start = this.$moment(midnight2).add(1, "day");

          const event1 = {
            ...event,
            end: new Date(event1End)
          };

          // const event2 = {
          //   ...event,
          //   start: new Date(event2Start)
          // };

          updatedEvents.push(event1);
        } else {
          updatedEvents.push(event);
        }
      });

      return updatedEvents;
    }
  },
  watch: {
    events(val) {
      if (!this.splitDays || !this.splitDays.length) {
        this.initSelectedDate();
        this.getSplitDays();
      }
      this.getCopyEvents();
    },
    hashData(val) {
      const hasDate = val ? val.date : false;
      if (hasDate) {
        if (this.selectedDate !== new Date(hasDate)) {
          this.selectedDate = new Date(hasDate);
        }
      } else {
        this.selectedDate = new Date();
      }
      this.getSplitDays();
    },
    selectedDate(value, prevValue) {
      if (value.toString() === prevValue.toString()) return;
      if (!this.showSaveSurgeriesButton) {
        this.$emit("setShowSaveSurgeriesButton", false);
      }
      this.getNonScheduleEvents();
      this.filterTodayEvents();
    },
    activeDoctor() {
      this.getNonScheduleEvents();
    }
  },
  async created() {
    this.initSelectedDate();
    if (!this.splitDays || !this.splitDays.length) this.getSplitDays();

    this.getCopyEvents();

    this.getNonScheduleEvents();

    setTimeout(() => {
      this.$emit("initCalendarDesktop", {
        currentDate: this.selectedDate,
        forceUpdate: true,
        type: "both"
      });
    }, 1500);

    /// listen to reschedule surgery
    this.$root.$on("rescheduleSurgery", () => {
      this.$emit("initCalendarDesktop", {
        currentDate: this.selectedDate,
        forceUpdate: true,
        type: "both"
      });
      this.getNonScheduleEvents();
    });
  }
};
</script>

<style>
.vuecal__event--dragging {
  background-color: rgba(60, 60, 60, 0.3);
  border: none;
}

.resched-txt {
  font-size: 16px;
}

.edited-non-schedule,
.vuecal__event.surgery:has(.edited-event) {
  background-color: #fff8ba !important;
}

img.sms-btn {
  width: 23px;
  position: relative;
  top: 1px;
}
#sms-label {
  margin: 0;
}
#sms-svg {
  width: 23px;
  height: 23px;
  margin: 0;
  display: inline;
}
#sms-line {
  margin: 0;
}
.bg-block {
  background-color: #fff8ba;
  color: #324997;
  border: 0;
  display: inline-block;
  font-family: NextExit, "Roboto Condensed";
  font-weight: 400;
  transition: all 0.3s ease-in-out;
  text-align: center;
  border-radius: 3px;
  cursor: pointer;
}
.bg-block:hover {
  background-color: #fff8ba;
}
</style>
